import React, {useCallback, useRef} from 'react';
import {createMicrolessonText} from '../createMicrolessonText';
import Button from '../../../uiToolkit/Buttons/Button';

interface Props {
  avatarFile?: File;
  setAvatarFile: (file: File) => void;
  existingAvatar?: string;
}

const FileUploadSection = React.memo(
  ({avatarFile, setAvatarFile, existingAvatar}: Props) => {
    const inputFile = useRef<any>(null);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        setAvatarFile(file);
      }
    };

    const onUpload = () => {
      inputFile.current.value = '';
      inputFile.current?.click();
    };

    const getPosterStyle = useCallback(() => {
      if (avatarFile) {
        return {
          backgroundImage: `url(${URL.createObjectURL(avatarFile)})`,
        };
      } else if (existingAvatar) {
        return {
          backgroundImage: `url(${existingAvatar})`,
        };
      }
    }, [avatarFile, existingAvatar]);

    return (
      <div className="UploadImageContainer" style={getPosterStyle()}>
        {avatarFile || existingAvatar ? (
          <div className="ImageSpacer" />
        ) : (
          <>
            <span className="icon-image"></span>
            <span className="InfoText">
              {createMicrolessonText.imageUploadInfo1}
            </span>
            <span className="InfoText">
              {createMicrolessonText.imageUploadInfo2}
            </span>
          </>
        )}
        <Button
          title={createMicrolessonText.browse}
          uiType="hollow_box"
          onClick={onUpload}
          className="BrowseButton"
        />
        <input
          type="file"
          onChange={onChange}
          accept="image/jpg,image/jpeg,image/png"
          style={{display: 'none'}}
          ref={inputFile}
        />
      </div>
    );
  },
);

export default FileUploadSection;
